// Definición de defaults

export const defaultTipoRecurrente: TipoRecurrenteProps = {
    idTipoRecurrente:   0,
    descripcion:        '',
    activo:             false,
};

// Creación de interfaces

export interface TipoRecurrenteProps   {
    idTipoRecurrente:   number;
    descripcion:        string;
    activo:             boolean;
}